import { network } from 'services/network';

export const exportSchedulingResultsAsVersion = (params) => {
    return network.post('api/bo/exportSchedulingResultsAsVersion', params).then((response) => response.data);
};
